import api from './api';
// @ts-ignore -- untyped JS module
import { Brand } from '../utils/cloud-campaign-utils';

export async function loadUserAgencies() {
  try {
    const response = await api.get('/rest/agency/loadUsersAgencies');
    return response.data;
  } catch (error) {
    console.error('Error fetching user agencies:', error);
    throw error;
  }
}

export interface AgencyWorkspace {
  id: string;
  companyName: string;
  iconUrl: string;
  workspaceTagIds?: (string | number)[];
  c2Status?: Record<string, any>;
  [key: string]: any;
}

export interface GetAgencyWorkspacesOptions {
  c2Only?: boolean;
  nameSearch?: string;
  workspaceTagIds?: (string | number)[];
  page: number;
  pageSize: number;
}

// Repeated `workspaceTags=` params, not axios's default `workspaceTags[]=`.
const buildQueryString = (options: GetAgencyWorkspacesOptions): string => {
  const params = new URLSearchParams();
  params.append('includeWorkspaceTags', 'true');
  params.append('page', String(options.page));
  params.append('pageSize', String(options.pageSize));
  (options.workspaceTagIds || []).forEach(tagId =>
    params.append('workspaceTags', String(tagId)),
  );
  if (options.nameSearch) {
    params.append('nameSearch', options.nameSearch);
  }
  if (options.c2Only) {
    params.append('c2Only', 'true');
  }
  return params.toString();
};

export const getAgencyWorkspaces = async (
  agencyId: string,
  options: GetAgencyWorkspacesOptions,
): Promise<{ results: AgencyWorkspace[]; totalCount: number }> => {
  try {
    const response = await api.get(
      `/rest/agency?${buildQueryString(options)}`,
      {
        headers: { 'x-agency-id': agencyId },
      },
    );
    const data = response.data;
    return {
      // Brand is the app-wide normalization for this endpoint's rows:
      // `name` wins over `companyName`, iconUrl falls back to the default.
      results: (data.results || []).map((row: any) => new Brand(row)),
      totalCount: data.totalCount ?? 0,
    };
  } catch (error) {
    console.log('Failed to load agency workspaces:', error);
    throw error;
  }
};
